import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()
export const apSearch = async (dominios: string[], grauSenioridade: string[],qtd_page: number, path: string): Promise<string> => {
    try {
        if (!dominios || !qtd_page || !path) return '';
        auth = getAuthState()
        const response = await fetch(`https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/ap/search`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            },
            body: JSON.stringify({
                dominios: dominios,
                grauSenioridade: grauSenioridade,
                qtd_page: qtd_page,
                path: path
            })
        });

        const data = await response.json();
        const id = data.body;
        return id
    } catch (error) {
        console.error('Error fetching files:', error);
        return '';
    }
};